module.exports = __webpack_public_path__ + "img/go.6c9f1f33.png";